import { render, staticRenderFns } from "./SectionPlatform.vue?vue&type=template&id=05e9e029&"
import script from "./SectionPlatform.vue?vue&type=script&lang=js&"
export * from "./SectionPlatform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports